module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tooltip":{"merchant":"Trocar Empresa"}},"en-US":{"tooltip":{"merchant":"Trocar Merchant"}}}')
  delete Component.options._Ctor
}
